<template>
  <div class="BlockVideos__inner">
    <div class="BlockVideos__main">
      <div class="BlockVideos__mainInner">

        <a
            href="#"
            @click.prevent="clickMain"
            class="add-shadow is-rounded"
            v-html="firstElement.image"
        ></a>
        <div class="BlockVideos__mainContent">
          <p>
            <strong v-html="firstElement.title"></strong>
            <br v-if="firstElement.description" />
            <span v-html="firstElement.description"></span>
          </p>
          <div
            class="small-url-link"
            v-if="firstElement.link"
            >
            <a
              :href="firstElement.link.url"
              :target="firstElement.link.target"
            >{{ firstElement.link.title }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="BlockVideos__list">
      <div
          class="BlockVideos__listItem"
          v-for="(item, index) in isMobile ? items : items.slice(1)"
          :key="index"
      >
        <div class="BlockVideos__listItemInner">
          <div class="BlockVideos__listItemImage add-shadow" v-html="item.thumbnail"></div>
          <div class="BlockVideos__listItemContent">
            <p>
              <strong v-html="item.title"></strong>
              <br v-if="item.description" />
              <span v-html="item.description"></span>
            </p>
          </div>
        </div>
        <a
          class="BlockVideos__listItemLink"
          href="#"
          @click.prevent="clickThumbnail(isMobile ? index : index + 1)"
        >
          <span class="is--visuallyHidden" v-html="item.title"></span>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import GLightbox from 'glightbox';
import { ref, computed } from 'vue'

const activeTab = ref(0)

const props = defineProps({
  items: {
    type: Array,
    required: true
  }
})

const firstElement = computed(() => {
  return props.items[activeTab.value]
})

const lightbox = GLightbox({
  elements: props.items.map((item) => {
    return {
      href: item.media_url,
    }
  }),
  touchNavigation: true,
  autoplayVideos: true,
});

const clickThumbnail = (index) => {
  activeTab.value = index
  lightbox.openAt(activeTab.value)
}

const clickMain = () => {
  lightbox.openAt(activeTab.value)
}

const screenWidth = ref(window.innerWidth)

const isMobile = computed(() => {
  return screenWidth.value <= 781
})

window.addEventListener('resize', () => {
  screenWidth.value = window.innerWidth
})
</script>